module.exports = __webpack_public_path__ + "media/images/icon-3891456300446d77c66b806c2d63bfa2.png";